var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgBgFeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "431px",
    height: "316px",
    viewBox: "0 0 431 316",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BBF57BDB-D58D-4A43-8020-9617BF0E02D6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.35,
    strokeDasharray: "0,0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NotarySoft-Website",
    transform: "translate(0.000000, -1699.000000)",
    stroke: "#FF8A8A",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG",
    transform: "translate(0.000000, 1699.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-77,322 C126.006798,306.846263 434.801358,191.611253 512,-264",
    id: "Vector-30"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBgFeat);
export default __webpack_public_path__ + "static/media/imgBgFeat.21e4591989d6dbb4840760766ce3e2cd.svg";
export { ForwardRef as ReactComponent };